export default __webpack_public_path__ + "static/media/light.79b01699.svg";